import { useEffect } from 'react';

/**
 * SEO Component for setting page title and meta tags
 * Since react-helmet-async may not be installed, we use document API directly
 */
const SEO = ({ 
  title, 
  description, 
  keywords, 
  canonical,
  ogImage,
  ogType = 'website'
}) => {
  useEffect(() => {
    // Set page title
    if (title) {
      document.title = title;
    }

    // Set or update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || '');
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      metaDescription.setAttribute('content', description || '');
      document.head.appendChild(metaDescription);
    }

    // Set or update meta keywords
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      } else {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        metaKeywords.setAttribute('content', keywords);
        document.head.appendChild(metaKeywords);
      }
    }

    // Set canonical URL
    if (canonical) {
      let linkCanonical = document.querySelector('link[rel="canonical"]');
      if (linkCanonical) {
        linkCanonical.setAttribute('href', canonical);
      } else {
        linkCanonical = document.createElement('link');
        linkCanonical.setAttribute('rel', 'canonical');
        linkCanonical.setAttribute('href', canonical);
        document.head.appendChild(linkCanonical);
      }
    }

    // Set Open Graph tags
    const setOGTag = (property, content) => {
      if (!content) return;
      let ogTag = document.querySelector(`meta[property="${property}"]`);
      if (ogTag) {
        ogTag.setAttribute('content', content);
      } else {
        ogTag = document.createElement('meta');
        ogTag.setAttribute('property', property);
        ogTag.setAttribute('content', content);
        document.head.appendChild(ogTag);
      }
    };

    if (title) setOGTag('og:title', title);
    if (description) setOGTag('og:description', description);
    if (canonical) setOGTag('og:url', canonical);
    if (ogImage) setOGTag('og:image', ogImage);
    setOGTag('og:type', ogType);

    // Set Twitter Card tags
    const setTwitterTag = (name, content) => {
      if (!content) return;
      let twitterTag = document.querySelector(`meta[name="twitter:${name}"]`);
      if (twitterTag) {
        twitterTag.setAttribute('content', content);
      } else {
        twitterTag = document.createElement('meta');
        twitterTag.setAttribute('name', `twitter:${name}`);
        twitterTag.setAttribute('content', content);
        document.head.appendChild(twitterTag);
      }
    };

    if (title) setTwitterTag('title', title);
    if (description) setTwitterTag('description', description);
    if (ogImage) setTwitterTag('image', ogImage);

  }, [title, description, keywords, canonical, ogImage, ogType]);

  return null; // This component doesn't render anything
};

export default SEO;

